/*eslint-disable */
import cacheLs from '../cacheLs'

export default {
  setPassionProjectResponse(state, response) {
    cacheLs.set_passion_project_response(response);
    state.passionProjectResponse = response;
    state.lastUpdatedTime = new Date().getTime();
  },
  removePassionProjectResponse(state) {
    cacheLs.remove_passion_project_response();
    state.passionProjectResponse = null;
    state.lastUpdatedTime = null;
  }
}